import { AnyAction } from 'redux';
import {
  FETCH_ADS_REQUEST,
  FETCH_ADS_SUCCESS,
  FETCH_ADS_FAILURE,
} from './actionType';

export const fetchAds = (): AnyAction => ({
  type: FETCH_ADS_REQUEST,
});

export const fetchAdsSuccess = (response: Object): AnyAction => ({
  type: FETCH_ADS_SUCCESS,
  payload: { response },
});

export const fetchAdsFailure = (error: Error | string): AnyAction => ({
  type: FETCH_ADS_FAILURE,
  payload: { error },
});
